import React, { useState, useEffect } from "react";
import { db } from "../services/firebase";
import { ref, onValue, update, remove } from "firebase/database";
import "./AdminVersionPanel.css";

function AdminVersionPanel() {
  const [versions, setVersions] = useState({});
  const [form, setForm] = useState({
    version: "",
    title: "",
    date: "",
    category: "history",
    type: "feature",
    features: ""
  });
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    const versionRef = ref(db, "Update/version");
    onValue(versionRef, (snap) => {
      setVersions(snap.val() || {});
    });
  }, []);

  const toDisplayVersion = (key) => key.replace(/_/g, ".");

  const handleInput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const { version, ...rest } = form;
    if (!version) return alert("⚠️ Version name is required");

    const safePath = version
      .split(".")
      .join("_")
      .split("_")
      .reduce((acc, part, i, arr) => {
        return acc + (i > 0 ? "/" : "") + arr.slice(0, i + 1).join("_");
      }, "");

    const versionRef = ref(db, `Update/version/${safePath}`);

    const featuresArray = form.features
      .split("\n")
      .map((f) => f.trim())
      .filter(Boolean);

    await update(versionRef, {
      ...rest,
      features: featuresArray,
    });

    alert("✅ Version saved successfully!");
    setForm({
      version: "",
      title: "",
      date: "",
      category: "history",
      type: "feature",
      features: "",
    });
  };

  const handleDelete = async (versionKey) => {
    if (window.confirm("Are you sure to delete this version?")) {
      const versionRef = ref(db, `Update/version/${versionKey}`);
      await remove(versionRef);
      alert("❌ Version deleted");
    }
  };

  const renderVersions = (data, base = "") => {
    return Object.entries(data).map(([key, value]) => {
      if (!value || typeof value !== "object") return null;
      const fullKey = base ? `${base}/${key}` : key;

      return (
        <details key={fullKey} className="version-entry" open>
          <summary>
            {value.category === "current" && "📌"}
            {value.category === "planned" && "🔮"}
            {value.category === "history" && "📗"}
            {value.category === "pending" && "⏳"}
            {value.category === "completed" && "✅"}
            {" "}
            {toDisplayVersion(key)} — <em>{value.title || "Untitled"}</em> ({value.type})
            <button className="delete-btn" onClick={() => handleDelete(fullKey)}>🗑️</button>
          </summary>

          <p><strong>Date:</strong> {value.date || "N/A"}</p>
          <p><strong>Type:</strong> {value.type || "N/A"}</p>

          {Array.isArray(value.features) && value.features.length > 0 && (
            <>
              <p><strong>Features:</strong></p>
              <ul>
                {value.features.map((f, i) => (
                  <li key={i}>{f}</li>
                ))}
              </ul>
            </>
          )}

          {/* Render nested sub-versions only if they're not array (avoid rendering features again) */}
          {Object.entries(value).some(([k, v]) => typeof v === "object" && !Array.isArray(v)) && (
            <div className="nested">{renderVersions(value, fullKey)}</div>
          )}
        </details>
      );
    });
  };

  return (
    <div className="container">
      <header className="header" >
        <h1>🧠 <span className="bold">Bodh</span><span className="accent">AI</span> — Version Log Admin</h1>
        <p className="tagline">Built for dreamers. Backed by data. Curated by AI.</p>

        <div style={{ marginTop: "1rem", display: "flex", gap: "10px" }}>
          <button className="submit-btn" onClick={() => setShowPanel(!showPanel)}>
            {showPanel ? "🙈 Hide Panel" : "📂 Show Version Panel"}
          </button>

          <button
            className="submit-btn"
            onClick={() => window.open("/versionaid", "_blank")}
          >
            🌐 Open Public Panel
          </button>
        </div>
      </header>

      {showPanel && (
        <>
          <section className="form-section">
            <h2>📤 Upload New Version</h2>
            <input
              type="text"
              name="version"
              placeholder="v1.0.3"
              value={form.version}
              onChange={handleInput}
            />
            <input
              type="text"
              name="title"
              placeholder="Title"
              value={form.title}
              onChange={handleInput}
            />
            <input
              type="text"
              name="date"
              placeholder="Release Date"
              value={form.date}
              onChange={handleInput}
            />
            <select name="category" value={form.category} onChange={handleInput}>
              <option value="pending">⏳ Pending</option>
              <option value="history">📗 History</option>
              <option value="current">📌 Current</option>
              <option value="planned">🔮 Planned</option>
              <option value="completed">✅ Completed</option>
              <option value="archive">📦 Archive</option>
              <option value="deprecated">🚫 Deprecated</option>
              <option value="experimental">🧪 Experimental</option>
              <option value="beta">🛠️ Beta</option>
              <option value="internal">🔒 Internal</option>
              <option value="external">🌐 External</option>
              <option value="community">🤝 Community</option>
              <option value="unreleased">🚧 Unreleased</option>
              <option value="testing">🧪 Testing</option>
              <option value="maintenance">🔧 Maintenance</option>
              

            </select>
            <select name="type" value={form.type} onChange={handleInput}>
              <option value="feature">🔄 Feature</option>
              <option value="public">✅ Public</option>
              <option value="private">🔒 Private</option>
              <option value="bugfix">🛠️ Bug Fix</option>
              <option value="security">🔐 Security</option>
              <option value="performance">⚡ Performance</option>
              <option value="ui">🎨 UI Update</option>
              <option value="other">❓ Other</option>
            </select>
            <textarea
              name="features"
              rows="5"
              placeholder="Enter each feature on a new line"
              value={form.features}
              onChange={handleInput}
            ></textarea>
            <button className="submit-btn" onClick={handleSubmit}>💾 Save Version</button>
          </section>

          <section className="version-history">
            <h2>📚 All Versions</h2>
            {renderVersions(versions)}
          </section>
        </>
      )}
    </div>
  );
}

export default AdminVersionPanel;
